import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useChatbotContext } from '../../../hooks/ChatbotContext';
import ChatCheckbox from '../ChatCheckbox';
import ChatDropdown from '../ChatDropdown';
import './ChatSettingsPopup.scss';

function ChatSettingsPopup({ className }) {
  const { t } = useTranslation(['chatbot']);
  const { enableExternalSearch, setEnableExternalSearch } = useChatbotContext();

  const handleToggle = (event) => {
    setEnableExternalSearch(event.target.checked);
  };

  return (
    <ChatDropdown className={`chat-settings-popup ${className || ''}`}>
      <div className="chat-settings-popup__content">
        <ChatCheckbox checked={enableExternalSearch} onChange={handleToggle} label={t('chatbot:Enable_web_search')} />
        <div className="chat-settings-popup__description">{t('chatbot:Allow_searching_web_sources')}</div>
      </div>
    </ChatDropdown>
  );
}

ChatSettingsPopup.propTypes = {
  className: PropTypes.string,
};

ChatSettingsPopup.defaultProps = {
  className: '',
};

export default ChatSettingsPopup;
